import { routeNames } from '../enum/routeNames';

const ERROR_ROUTES = [
  routeNames.SERVER_ERROR,
  routeNames.AUTH_EXPIRED,
  routeNames.NOT_FOUND,
];

export const isErrorRoute = routeName => ERROR_ROUTES.includes(routeName);
